import {
  day_row,
  dimensiondata_1_tetelek_group_dimension_1_column,
  month_row_expanded,
  szazaleksz_value_1_data_precision_no_year_month_summary,
  year_row_expanded,
  order_1,
  order_2
} from '../../fields';
import { PivotGridConfig } from '../../utils/pivot-grid-config';

export const termeloiTaroloiKihasznaltsagConfig: PivotGridConfig = {
  showChart: false,
  filterYear: {},
  options: {
    store: {
      version: 4,
      type: 'odata',
      url: 'odata/v4/public/TermeloiTaroloiKihasznaltsag',
      select: ['date', 'dimension_1', 'value_1'],
      beforeSend: (e: any) => {
        e.headers = {
          Accept: 'application/json;odata.metadata=none',
        };
      },
    },
    retrieveFields: false,
    fields: [
      year_row_expanded,
      month_row_expanded,
      day_row,
      ...dimensiondata_1_tetelek_group_dimension_1_column,
      szazaleksz_value_1_data_precision_no_year_month_summary,
      order_1,
      order_2
    ],
  },
};
